// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let MultipleChoiceQuestionEditor
const QuestionOption = require("assessments/models/question-option").default
const QuestionOptionView = require("./question-option").default

export default MultipleChoiceQuestionEditor = (function () {
  MultipleChoiceQuestionEditor = class MultipleChoiceQuestionEditor extends (
    require("lib/static-shim").default(require("./question-editor").default)
  ) {
    static initClass() {
      this.prototype.template = require("./templates/multiple-choice-question.html")
      this.prototype.options = []

      this.prototype.ui = {
        addAnswerExplanation: ".add-answer-explanation",
        options: ".multiple-choice-options",
        answerExplanation: ".answer-explanation-container"
      }

      this.prototype.events = { "keyup li input": "onChangeOption" }

      this.prototype.triggers = {
        "click @ui.addAnswerExplanation": "show:answer:explanation"
      }

      this.prototype.modelEvents = { "options:changed": "_setOptions" }
    }

    initialize() {
      super.initialize()
      return (this.options = [])
    }

    onRender() {
      // TODO: render a collection view for options

      if (this.model.get("wrong_answer_tip")) {
        this.onShowAnswerExplanation()
      }

      // render the options
      for (let opData of Array.from(this.model.get("options"))) {
        const op = new QuestionOption(opData)
        op.question = this.model
        const opView = new QuestionOptionView({ model: op })
        this.ui.options.append(opView.render().el)
        this.listenTo(opView, "options:change", this._setOptions)
        this.options.push(opView)
      }

      // add a blank option for new...
      this.addNewOption()

      // allow sortting of options
      this.ui.options.sortable({
        items: "li:not(.new)",
        handle: ".move",
        placeholder: "placeholder",
        forcePlaceholderSize: true,
        helper: "clone",
        update: (e, ui) => this._setOptions()
      })

      // initi tooltips
      return this.$("a.tipsy").tipsy()
    }

    onShowAnswerExplanation() {
      this.ui.addAnswerExplanation.hide()
      return this.ui.answerExplanation.show()
    }

    getOptions() {
      const options = []
      // add the options...
      this.$(".question-option:not(.new)").each((i, el) => {
        const $op = $(el)
        const op = {}
        const { id } = $op.data()
        if (id != null && id !== "") {
          op.id = id
        }
        op.text = $op.find("input").val()
        op.is_correct_answer = $op.hasClass("correct")
        op.order = i + 1
        if (op.text.length) {
          return options.push(op)
        }
      })
      return options
    }

    onChangeOption(e) {
      const v = $(e.currentTarget).val()
      const $op = $(e.currentTarget).parent()
      $op.toggleClass("new", v.length === 0)
      this._setOptions()
      return this.addNewOption()
    }

    _setOptions() {
      return this.model.set("options", this.getOptions())
    }

    onBeforeDestroy() {
      try {
        return this.ui.options.sortable("destroy")
      } catch (err) {
        return console.log("error destroying sortable: ", err)
      }
    }

    removeNewOptions() {
      // Gives the following jQuery error in the console:
      // Uncaught TypeError: Cannot read property 'nodeName' of null
      // Not sure why this error comes
      return this.ui.options.find(".new:not(:last)").remove()
    }

    addNewOption() {
      if (this.ui.options.find(".new").length > 0) {
        // @removeNewOptions()
        return
      }
      const option = new QuestionOption({
        order: this.model.get("options").length + 1
      })
      option.question = this.model
      return this.ui.options.append(
        new QuestionOptionView({ model: option }).render().el
      )
    }
  }
  MultipleChoiceQuestionEditor.initClass()
  return MultipleChoiceQuestionEditor
})()
